// src/Store/Slice/UserSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: "",
  user: { fullname: "", isComplete: false }, // full user object from backend
  role: "", // "customer" | "provider" (decoded from token response role if you set it)
  isLoggedIn: false,
};

const userSlice = createSlice({
  name: "userSlice",
  initialState,
  reducers: {
    // ✅ one reducer: can update one field or many fields
    updateUser(state, action) {
      // payload examples:
      // { token }
      // { user }
      // { token, user, role, isLoggedIn }


      Object.assign(state, action.payload);

      // auto flags if token provided
      if (action.payload?.token !== undefined) {
        state.isLoggedIn = Boolean(action.payload.token);
      }
    },

    // ✅ set from otp response
    setAuthFromOtp(state, action) {
      // expects backend response: { data: { user, token } }
      const token = action.payload?.data?.token || action.payload?.token || "";
      const user = action.payload?.data?.user || action.payload?.user || null;

      state.token = token;
      state.user = user;
      state.isLoggedIn = Boolean(token);
    },

    logout() {
      return initialState;
    },
  },
});

export const { updateUser, setAuthFromOtp, logout } = userSlice.actions;
export default userSlice.reducer;

// selectors (optional)
export const { token, user } = (state) => state.userSlice.token;
export const selectUser = (state) => state.userSlice.user;
export const selectIsLoggedIn = (state) => state.userSlice.isLoggedIn;
